import { render, staticRenderFns } from "./TrWord.vue?vue&type=template&id=0d6201cc&scoped=true&"
import script from "./TrWord.vue?vue&type=script&lang=js&"
export * from "./TrWord.vue?vue&type=script&lang=js&"
import style0 from "./TrWord.vue?vue&type=style&index=0&id=0d6201cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6201cc",
  null
  
)

export default component.exports